import {
  AccountContainer,
  DownloadContainer,
  NotFoundContainer,
  OnboardingContainer,
  SolarContainer,
} from '../containers';
import { Navigate, Route, Routes } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

import { ConsentProvider } from '../context/ConsentContext';
import LoopSpinner from '../ui/LoopSpinner';
import ReconfirmContainer from '../containers/ReconfirmContainer';
import { getUserMpans } from '../api/SmartMeter';
import styled from 'styled-components';

const StyledDiv = styled.div`
  min-height: 100vh;
`;

const AppRouter = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isOnboarded, setIsOnboarded] = useState(false);

  useEffect(() => {
    getUserMpans().then(userMpans => {
      if (!!userMpans?.length) {
        setIsOnboarded(true);
      }
      setIsLoading(false);
    });
  }, [setIsOnboarded, setIsLoading]);

  return (
    <>
      {isLoading ? (
        <StyledDiv className="d-flex align-items-center justify-content-center">
          <LoopSpinner />
        </StyledDiv>
      ) : (
        <ConsentProvider>
          <Routes>
            <Route path="/account/*" element={<AccountContainer />} />
            <Route path="/download" element={<DownloadContainer />} />
            <Route path="/reconfirm/*" element={<ReconfirmContainer />} />
            {!isOnboarded && (
              <Route path="/onboarding/*" element={<OnboardingContainer />} />
            )}

            <Route
              path="/"
              element={
                !isOnboarded ? (
                  <Navigate to="/onboarding" />
                ) : (
                  <Navigate to="/account" />
                )
              }
            />

            <Route path="/solar/*" element={<SolarContainer />} />
            <Route path="/signup" element={<Navigate to="/" />} />

            {/* Catch-all route */}
            <Route path="*" element={<NotFoundContainer />} />
          </Routes>
        </ConsentProvider>
      )}
    </>
  );
};

export default AppRouter;
